import apiClient, { type PagedResponse } from '../../client'
import type {
  ComponentTypeItem,
  CreateComponentTypeRequest,
  UpdateComponentTypeRequest,
  GetComponentTypesParams,
} from '../../models/maestros.models'

const BASE_PATH = '/maestros/component-types'

export const componentTypesService = {
  async getAll(params?: GetComponentTypesParams): Promise<PagedResponse<ComponentTypeItem>> {
    return apiClient.get<PagedResponse<ComponentTypeItem>>(BASE_PATH, params)
  },
  async getById(id: string): Promise<ComponentTypeItem> {
    return apiClient.get<ComponentTypeItem>(`${BASE_PATH}/${id}`)
  },
  async create(data: CreateComponentTypeRequest): Promise<ComponentTypeItem> {
    return apiClient.post<ComponentTypeItem, CreateComponentTypeRequest>(BASE_PATH, data)
  },
  async update(id: string, data: UpdateComponentTypeRequest): Promise<ComponentTypeItem> {
    return apiClient.put<ComponentTypeItem, UpdateComponentTypeRequest>(`${BASE_PATH}/${id}`, data)
  },
  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}`)
  },
}
